import { render, staticRenderFns } from "./ProposalCompensationRouterView.vue?vue&type=template&id=5a5bb634&"
import script from "./ProposalCompensationRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalCompensationRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports